import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { container, fadeUp } from '@/constants/motion';
import { Layers, Link2, MapPin } from 'lucide-react';
const CARD_META = [
    {
        Icon: Layers,
        iconColor: 'text-violet-500',
        iconBg: 'bg-violet-100 dark:bg-violet-900/30',
    },
    {
        Icon: Link2,
        iconColor: 'text-blue-500',
        iconBg: 'bg-blue-100 dark:bg-blue-900/30',
    },
    {
        Icon: MapPin,
        iconColor: 'text-emerald-500',
        iconBg: 'bg-emerald-100 dark:bg-emerald-900/30',
    },
];
export const WhatIsAdora = () => {
    const { t } = useTranslation('marketing');
    const cards = [
        {
            title: t('landing.whatIs.cards.campaignFirst.title'),
            body: t('landing.whatIs.cards.campaignFirst.body'),
        },
        {
            title: t('landing.whatIs.cards.manyLinksOneQr.title'),
            body: t('landing.whatIs.cards.manyLinksOneQr.body'),
        },
        {
            title: t('landing.whatIs.cards.offlineToData.title'),
            body: t('landing.whatIs.cards.offlineToData.body'),
        },
    ];
    return (<motion.section className="border-b bg-background" initial="hidden" whileInView="visible" viewport={{ once: true, margin: '-80px' }} variants={container}>
            <div className="mx-auto max-w-5xl px-4 py-16 md:py-20">
                {/* Heading */}
                <motion.div variants={container} className="text-center">
                    <motion.p variants={fadeUp} className="text-xs font-semibold uppercase tracking-widest text-primary mb-3">
                        What is Adora
                    </motion.p>
                    <motion.h2 variants={fadeUp} className="text-3xl font-bold md:text-4xl">
                        {t('landing.whatIs.title')}
                    </motion.h2>
                    <motion.p variants={fadeUp} className="mt-3 text-sm text-muted-foreground md:text-base max-w-2xl mx-auto leading-relaxed">
                        {t('landing.whatIs.subtitle')}
                    </motion.p>
                </motion.div>

                {/* Cards */}
                <motion.div variants={container} className="mt-12 grid gap-6 md:grid-cols-3">
                    {cards.map((card, i) => {
            const { Icon, iconColor, iconBg } = CARD_META[i];
            return (<motion.div key={card.title} variants={fadeUp} whileHover={{ y: -4, transition: { duration: 0.18 } }} className="flex flex-col gap-4 rounded-2xl border bg-card p-6">
                                <div className={`inline-flex h-10 w-10 items-center justify-center rounded-xl ${iconBg}`}>
                                    <Icon className={`h-5 w-5 ${iconColor}`}/>
                                </div>
                                <div>
                                    <h3 className="text-sm font-semibold mb-1.5 text-foreground">{card.title}</h3>
                                    <p className="text-sm text-muted-foreground leading-relaxed">{card.body}</p>
                                </div>
                            </motion.div>);
        })}
                </motion.div>
            </div>
        </motion.section>);
};
WhatIsAdora.displayName = 'WhatIsAdora';
